/* TK's related products: reliable responsive product-by-product navigation */
(() => {
  'use strict';
  const selector = '.tks-gallery-related';
  function init(root) {
    if (root.dataset.tksRelatedInitialized === 'true') return;
    const viewport = root.querySelector('[data-tks-related-viewport]');
    const items = Array.from(root.querySelectorAll('.tks-gallery-related__item'));
    const prev = root.querySelector('[data-tks-related-prev]');
    const next = root.querySelector('[data-tks-related-next]');
    if (!viewport || !items.length || !prev || !next) return;
    root.dataset.tksRelatedInitialized = 'true';
    const maxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const update = () => {
      const max = maxScroll();
      prev.disabled = viewport.scrollLeft <= 3;
      next.disabled = max - viewport.scrollLeft <= 3;
    };
    const move = direction => {
      const left = viewport.scrollLeft;
      const max = maxScroll();
      if (max < 2) return;
      const lefts = items.map(item => Math.max(0, Math.min(max, item.offsetLeft - items[0].offsetLeft)));
      let target;
      if (direction > 0) target = lefts.find(x => x > left + 3);
      else target = [...lefts].reverse().find(x => x < left - 3);
      if (typeof target !== 'number') target = direction > 0 ? max : 0;
      viewport.scrollTo({left:target, behavior:'smooth'});
      // Reconcile state after smooth scrolling and snap alignment.
      window.setTimeout(update, 450);
    };
    prev.addEventListener('click', event => {event.preventDefault();event.stopPropagation();move(-1);});
    next.addEventListener('click', event => {event.preventDefault();event.stopPropagation();move(1);});
    viewport.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(viewport);
    update();
  }
  const initAll = root => {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll?.(selector).forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document), {once:true});
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();